/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as AuthenticatedAccountSettingsRouteRouteImport } from './routes/_authenticated/account-settings/route'
import { Route as AuthenticatedWalletIndexRouteImport } from './routes/_authenticated/wallet/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTermsOfServiceIndexRouteImport } from './routes/_authenticated/terms-of-service/index'
import { Route as AuthenticatedShowcasesIndexRouteImport } from './routes/_authenticated/showcases/index'
import { Route as AuthenticatedPrivacyPolicyIndexRouteImport } from './routes/_authenticated/privacy-policy/index'
import { Route as AuthenticatedMyCampaignsIndexRouteImport } from './routes/_authenticated/my-campaigns/index'
import { Route as AuthenticatedLeaderboardIndexRouteImport } from './routes/_authenticated/leaderboard/index'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns/index'
import { Route as AuthenticatedBlogsIndexRouteImport } from './routes/_authenticated/blogs/index'
import { Route as AuthenticatedAccountSettingsIndexRouteImport } from './routes/_authenticated/account-settings/index'
import { Route as AuthenticatedUsernameIndexRouteImport } from './routes/_authenticated/$username/index'
import { Route as AuthenticatedRCodeRouteImport } from './routes/_authenticated/r/$code'
import { Route as AuthenticatedAccountSettingsSecurityRouteImport } from './routes/_authenticated/account-settings/security'
import { Route as AuthenticatedAccountSettingsReferralsRouteImport } from './routes/_authenticated/account-settings/referrals'
import { Route as AuthenticatedAccountSettingsPreferencesRouteImport } from './routes/_authenticated/account-settings/preferences'
import { Route as AuthenticatedAccountSettingsGeneralRouteImport } from './routes/_authenticated/account-settings/general'
import { Route as AuthenticatedAccountSettingsConnectedAccountsRouteImport } from './routes/_authenticated/account-settings/connected-accounts'
import { Route as AuthenticatedShowcasesShowcaseIdIndexRouteImport } from './routes/_authenticated/showcases/$showcaseId/index'
import { Route as AuthenticatedIdIdIndexRouteImport } from './routes/_authenticated/id/$id/index'
import { Route as AuthenticatedCampaignsIdIndexRouteImport } from './routes/_authenticated/campaigns/$id/index'
import { Route as AuthenticatedBlogsSlugIndexRouteImport } from './routes/_authenticated/blogs/$slug/index'
import { Route as AuthenticatedCampaignsIdManageRouteImport } from './routes/_authenticated/campaigns/$id/manage'
import { Route as AuthenticatedCampaignsIdClipperRouteImport } from './routes/_authenticated/campaigns/$id/clipper'

const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountSettingsRouteRoute =
  AuthenticatedAccountSettingsRouteRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletIndexRoute =
  AuthenticatedWalletIndexRouteImport.update({
    id: '/wallet/',
    path: '/wallet/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTermsOfServiceIndexRoute =
  AuthenticatedTermsOfServiceIndexRouteImport.update({
    id: '/terms-of-service/',
    path: '/terms-of-service/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedShowcasesIndexRoute =
  AuthenticatedShowcasesIndexRouteImport.update({
    id: '/showcases/',
    path: '/showcases/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPrivacyPolicyIndexRoute =
  AuthenticatedPrivacyPolicyIndexRouteImport.update({
    id: '/privacy-policy/',
    path: '/privacy-policy/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMyCampaignsIndexRoute =
  AuthenticatedMyCampaignsIndexRouteImport.update({
    id: '/my-campaigns/',
    path: '/my-campaigns/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLeaderboardIndexRoute =
  AuthenticatedLeaderboardIndexRouteImport.update({
    id: '/leaderboard/',
    path: '/leaderboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBlogsIndexRoute = AuthenticatedBlogsIndexRouteImport.update({
  id: '/blogs/',
  path: '/blogs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccountSettingsIndexRoute =
  AuthenticatedAccountSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedUsernameIndexRoute =
  AuthenticatedUsernameIndexRouteImport.update({
    id: '/$username/',
    path: '/$username/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRCodeRoute = AuthenticatedRCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAccountSettingsSecurityRoute =
  AuthenticatedAccountSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedAccountSettingsReferralsRoute =
  AuthenticatedAccountSettingsReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedAccountSettingsPreferencesRoute =
  AuthenticatedAccountSettingsPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedAccountSettingsGeneralRoute =
  AuthenticatedAccountSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedAccountSettingsConnectedAccountsRoute =
  AuthenticatedAccountSettingsConnectedAccountsRouteImport.update({
    id: '/connected-accounts',
    path: '/connected-accounts',
    getParentRoute: () => AuthenticatedAccountSettingsRouteRoute,
  } as any)
const AuthenticatedShowcasesShowcaseIdIndexRoute =
  AuthenticatedShowcasesShowcaseIdIndexRouteImport.update({
    id: '/showcases/$showcaseId/',
    path: '/showcases/$showcaseId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIdIdIndexRoute = AuthenticatedIdIdIndexRouteImport.update({
  id: '/id/$id/',
  path: '/id/$id/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCampaignsIdIndexRoute =
  AuthenticatedCampaignsIdIndexRouteImport.update({
    id: '/campaigns/$id/',
    path: '/campaigns/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBlogsSlugIndexRoute =
  AuthenticatedBlogsSlugIndexRouteImport.update({
    id: '/blogs/$slug/',
    path: '/blogs/$slug/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCampaignsIdManageRoute =
  AuthenticatedCampaignsIdManageRouteImport.update({
    id: '/campaigns/$id/manage',
    path: '/campaigns/$id/manage',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCampaignsIdClipperRoute =
  AuthenticatedCampaignsIdClipperRouteImport.update({
    id: '/campaigns/$id/clipper',
    path: '/campaigns/$id/clipper',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/account-settings': typeof AuthenticatedAccountSettingsRouteRouteWithChildren
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/account-settings/connected-accounts': typeof AuthenticatedAccountSettingsConnectedAccountsRoute
  '/account-settings/general': typeof AuthenticatedAccountSettingsGeneralRoute
  '/account-settings/preferences': typeof AuthenticatedAccountSettingsPreferencesRoute
  '/account-settings/referrals': typeof AuthenticatedAccountSettingsReferralsRoute
  '/account-settings/security': typeof AuthenticatedAccountSettingsSecurityRoute
  '/r/$code': typeof AuthenticatedRCodeRoute
  '/$username/': typeof AuthenticatedUsernameIndexRoute
  '/account-settings/': typeof AuthenticatedAccountSettingsIndexRoute
  '/blogs/': typeof AuthenticatedBlogsIndexRoute
  '/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/leaderboard/': typeof AuthenticatedLeaderboardIndexRoute
  '/my-campaigns/': typeof AuthenticatedMyCampaignsIndexRoute
  '/privacy-policy/': typeof AuthenticatedPrivacyPolicyIndexRoute
  '/showcases/': typeof AuthenticatedShowcasesIndexRoute
  '/terms-of-service/': typeof AuthenticatedTermsOfServiceIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/wallet/': typeof AuthenticatedWalletIndexRoute
  '/campaigns/$id/clipper': typeof AuthenticatedCampaignsIdClipperRoute
  '/campaigns/$id/manage': typeof AuthenticatedCampaignsIdManageRoute
  '/blogs/$slug/': typeof AuthenticatedBlogsSlugIndexRoute
  '/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
  '/id/$id/': typeof AuthenticatedIdIdIndexRoute
  '/showcases/$showcaseId/': typeof AuthenticatedShowcasesShowcaseIdIndexRoute
}
export interface FileRoutesByTo {
  '/sso-callback': typeof SsoCallbackRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/account-settings/connected-accounts': typeof AuthenticatedAccountSettingsConnectedAccountsRoute
  '/account-settings/general': typeof AuthenticatedAccountSettingsGeneralRoute
  '/account-settings/preferences': typeof AuthenticatedAccountSettingsPreferencesRoute
  '/account-settings/referrals': typeof AuthenticatedAccountSettingsReferralsRoute
  '/account-settings/security': typeof AuthenticatedAccountSettingsSecurityRoute
  '/r/$code': typeof AuthenticatedRCodeRoute
  '/$username': typeof AuthenticatedUsernameIndexRoute
  '/account-settings': typeof AuthenticatedAccountSettingsIndexRoute
  '/blogs': typeof AuthenticatedBlogsIndexRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/leaderboard': typeof AuthenticatedLeaderboardIndexRoute
  '/my-campaigns': typeof AuthenticatedMyCampaignsIndexRoute
  '/privacy-policy': typeof AuthenticatedPrivacyPolicyIndexRoute
  '/showcases': typeof AuthenticatedShowcasesIndexRoute
  '/terms-of-service': typeof AuthenticatedTermsOfServiceIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/wallet': typeof AuthenticatedWalletIndexRoute
  '/campaigns/$id/clipper': typeof AuthenticatedCampaignsIdClipperRoute
  '/campaigns/$id/manage': typeof AuthenticatedCampaignsIdManageRoute
  '/blogs/$slug': typeof AuthenticatedBlogsSlugIndexRoute
  '/campaigns/$id': typeof AuthenticatedCampaignsIdIndexRoute
  '/id/$id': typeof AuthenticatedIdIdIndexRoute
  '/showcases/$showcaseId': typeof AuthenticatedShowcasesShowcaseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/_authenticated/account-settings': typeof AuthenticatedAccountSettingsRouteRouteWithChildren
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/account-settings/connected-accounts': typeof AuthenticatedAccountSettingsConnectedAccountsRoute
  '/_authenticated/account-settings/general': typeof AuthenticatedAccountSettingsGeneralRoute
  '/_authenticated/account-settings/preferences': typeof AuthenticatedAccountSettingsPreferencesRoute
  '/_authenticated/account-settings/referrals': typeof AuthenticatedAccountSettingsReferralsRoute
  '/_authenticated/account-settings/security': typeof AuthenticatedAccountSettingsSecurityRoute
  '/_authenticated/r/$code': typeof AuthenticatedRCodeRoute
  '/_authenticated/$username/': typeof AuthenticatedUsernameIndexRoute
  '/_authenticated/account-settings/': typeof AuthenticatedAccountSettingsIndexRoute
  '/_authenticated/blogs/': typeof AuthenticatedBlogsIndexRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/_authenticated/leaderboard/': typeof AuthenticatedLeaderboardIndexRoute
  '/_authenticated/my-campaigns/': typeof AuthenticatedMyCampaignsIndexRoute
  '/_authenticated/privacy-policy/': typeof AuthenticatedPrivacyPolicyIndexRoute
  '/_authenticated/showcases/': typeof AuthenticatedShowcasesIndexRoute
  '/_authenticated/terms-of-service/': typeof AuthenticatedTermsOfServiceIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/wallet/': typeof AuthenticatedWalletIndexRoute
  '/_authenticated/campaigns/$id/clipper': typeof AuthenticatedCampaignsIdClipperRoute
  '/_authenticated/campaigns/$id/manage': typeof AuthenticatedCampaignsIdManageRoute
  '/_authenticated/blogs/$slug/': typeof AuthenticatedBlogsSlugIndexRoute
  '/_authenticated/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
  '/_authenticated/id/$id/': typeof AuthenticatedIdIdIndexRoute
  '/_authenticated/showcases/$showcaseId/': typeof AuthenticatedShowcasesShowcaseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sso-callback'
    | '/account-settings'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/account-settings/connected-accounts'
    | '/account-settings/general'
    | '/account-settings/preferences'
    | '/account-settings/referrals'
    | '/account-settings/security'
    | '/r/$code'
    | '/$username/'
    | '/account-settings/'
    | '/blogs/'
    | '/campaigns/'
    | '/leaderboard/'
    | '/my-campaigns/'
    | '/privacy-policy/'
    | '/showcases/'
    | '/terms-of-service/'
    | '/users/'
    | '/wallet/'
    | '/campaigns/$id/clipper'
    | '/campaigns/$id/manage'
    | '/blogs/$slug/'
    | '/campaigns/$id/'
    | '/id/$id/'
    | '/showcases/$showcaseId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sso-callback'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/account-settings/connected-accounts'
    | '/account-settings/general'
    | '/account-settings/preferences'
    | '/account-settings/referrals'
    | '/account-settings/security'
    | '/r/$code'
    | '/$username'
    | '/account-settings'
    | '/blogs'
    | '/campaigns'
    | '/leaderboard'
    | '/my-campaigns'
    | '/privacy-policy'
    | '/showcases'
    | '/terms-of-service'
    | '/users'
    | '/wallet'
    | '/campaigns/$id/clipper'
    | '/campaigns/$id/manage'
    | '/blogs/$slug'
    | '/campaigns/$id'
    | '/id/$id'
    | '/showcases/$showcaseId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sso-callback'
    | '/_authenticated/account-settings'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/account-settings/connected-accounts'
    | '/_authenticated/account-settings/general'
    | '/_authenticated/account-settings/preferences'
    | '/_authenticated/account-settings/referrals'
    | '/_authenticated/account-settings/security'
    | '/_authenticated/r/$code'
    | '/_authenticated/$username/'
    | '/_authenticated/account-settings/'
    | '/_authenticated/blogs/'
    | '/_authenticated/campaigns/'
    | '/_authenticated/leaderboard/'
    | '/_authenticated/my-campaigns/'
    | '/_authenticated/privacy-policy/'
    | '/_authenticated/showcases/'
    | '/_authenticated/terms-of-service/'
    | '/_authenticated/users/'
    | '/_authenticated/wallet/'
    | '/_authenticated/campaigns/$id/clipper'
    | '/_authenticated/campaigns/$id/manage'
    | '/_authenticated/blogs/$slug/'
    | '/_authenticated/campaigns/$id/'
    | '/_authenticated/id/$id/'
    | '/_authenticated/showcases/$showcaseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  SsoCallbackRoute: typeof SsoCallbackRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account-settings': {
      id: '/_authenticated/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AuthenticatedAccountSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/': {
      id: '/_authenticated/wallet/'
      path: '/wallet'
      fullPath: '/wallet/'
      preLoaderRoute: typeof AuthenticatedWalletIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/terms-of-service/': {
      id: '/_authenticated/terms-of-service/'
      path: '/terms-of-service'
      fullPath: '/terms-of-service/'
      preLoaderRoute: typeof AuthenticatedTermsOfServiceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/showcases/': {
      id: '/_authenticated/showcases/'
      path: '/showcases'
      fullPath: '/showcases/'
      preLoaderRoute: typeof AuthenticatedShowcasesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/privacy-policy/': {
      id: '/_authenticated/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy/'
      preLoaderRoute: typeof AuthenticatedPrivacyPolicyIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-campaigns/': {
      id: '/_authenticated/my-campaigns/'
      path: '/my-campaigns'
      fullPath: '/my-campaigns/'
      preLoaderRoute: typeof AuthenticatedMyCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leaderboard/': {
      id: '/_authenticated/leaderboard/'
      path: '/leaderboard'
      fullPath: '/leaderboard/'
      preLoaderRoute: typeof AuthenticatedLeaderboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blogs/': {
      id: '/_authenticated/blogs/'
      path: '/blogs'
      fullPath: '/blogs/'
      preLoaderRoute: typeof AuthenticatedBlogsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/account-settings/': {
      id: '/_authenticated/account-settings/'
      path: '/'
      fullPath: '/account-settings/'
      preLoaderRoute: typeof AuthenticatedAccountSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/$username/': {
      id: '/_authenticated/$username/'
      path: '/$username'
      fullPath: '/$username/'
      preLoaderRoute: typeof AuthenticatedUsernameIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/r/$code': {
      id: '/_authenticated/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof AuthenticatedRCodeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/account-settings/security': {
      id: '/_authenticated/account-settings/security'
      path: '/security'
      fullPath: '/account-settings/security'
      preLoaderRoute: typeof AuthenticatedAccountSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/account-settings/referrals': {
      id: '/_authenticated/account-settings/referrals'
      path: '/referrals'
      fullPath: '/account-settings/referrals'
      preLoaderRoute: typeof AuthenticatedAccountSettingsReferralsRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/account-settings/preferences': {
      id: '/_authenticated/account-settings/preferences'
      path: '/preferences'
      fullPath: '/account-settings/preferences'
      preLoaderRoute: typeof AuthenticatedAccountSettingsPreferencesRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/account-settings/general': {
      id: '/_authenticated/account-settings/general'
      path: '/general'
      fullPath: '/account-settings/general'
      preLoaderRoute: typeof AuthenticatedAccountSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/account-settings/connected-accounts': {
      id: '/_authenticated/account-settings/connected-accounts'
      path: '/connected-accounts'
      fullPath: '/account-settings/connected-accounts'
      preLoaderRoute: typeof AuthenticatedAccountSettingsConnectedAccountsRouteImport
      parentRoute: typeof AuthenticatedAccountSettingsRouteRoute
    }
    '/_authenticated/showcases/$showcaseId/': {
      id: '/_authenticated/showcases/$showcaseId/'
      path: '/showcases/$showcaseId'
      fullPath: '/showcases/$showcaseId/'
      preLoaderRoute: typeof AuthenticatedShowcasesShowcaseIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/id/$id/': {
      id: '/_authenticated/id/$id/'
      path: '/id/$id'
      fullPath: '/id/$id/'
      preLoaderRoute: typeof AuthenticatedIdIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/$id/': {
      id: '/_authenticated/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id/'
      preLoaderRoute: typeof AuthenticatedCampaignsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blogs/$slug/': {
      id: '/_authenticated/blogs/$slug/'
      path: '/blogs/$slug'
      fullPath: '/blogs/$slug/'
      preLoaderRoute: typeof AuthenticatedBlogsSlugIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/$id/manage': {
      id: '/_authenticated/campaigns/$id/manage'
      path: '/campaigns/$id/manage'
      fullPath: '/campaigns/$id/manage'
      preLoaderRoute: typeof AuthenticatedCampaignsIdManageRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/$id/clipper': {
      id: '/_authenticated/campaigns/$id/clipper'
      path: '/campaigns/$id/clipper'
      fullPath: '/campaigns/$id/clipper'
      preLoaderRoute: typeof AuthenticatedCampaignsIdClipperRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedAccountSettingsRouteRouteChildren {
  AuthenticatedAccountSettingsConnectedAccountsRoute: typeof AuthenticatedAccountSettingsConnectedAccountsRoute
  AuthenticatedAccountSettingsGeneralRoute: typeof AuthenticatedAccountSettingsGeneralRoute
  AuthenticatedAccountSettingsPreferencesRoute: typeof AuthenticatedAccountSettingsPreferencesRoute
  AuthenticatedAccountSettingsReferralsRoute: typeof AuthenticatedAccountSettingsReferralsRoute
  AuthenticatedAccountSettingsSecurityRoute: typeof AuthenticatedAccountSettingsSecurityRoute
  AuthenticatedAccountSettingsIndexRoute: typeof AuthenticatedAccountSettingsIndexRoute
}

const AuthenticatedAccountSettingsRouteRouteChildren: AuthenticatedAccountSettingsRouteRouteChildren =
  {
    AuthenticatedAccountSettingsConnectedAccountsRoute:
      AuthenticatedAccountSettingsConnectedAccountsRoute,
    AuthenticatedAccountSettingsGeneralRoute:
      AuthenticatedAccountSettingsGeneralRoute,
    AuthenticatedAccountSettingsPreferencesRoute:
      AuthenticatedAccountSettingsPreferencesRoute,
    AuthenticatedAccountSettingsReferralsRoute:
      AuthenticatedAccountSettingsReferralsRoute,
    AuthenticatedAccountSettingsSecurityRoute:
      AuthenticatedAccountSettingsSecurityRoute,
    AuthenticatedAccountSettingsIndexRoute:
      AuthenticatedAccountSettingsIndexRoute,
  }

const AuthenticatedAccountSettingsRouteRouteWithChildren =
  AuthenticatedAccountSettingsRouteRoute._addFileChildren(
    AuthenticatedAccountSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAccountSettingsRouteRoute: typeof AuthenticatedAccountSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedRCodeRoute: typeof AuthenticatedRCodeRoute
  AuthenticatedUsernameIndexRoute: typeof AuthenticatedUsernameIndexRoute
  AuthenticatedBlogsIndexRoute: typeof AuthenticatedBlogsIndexRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
  AuthenticatedLeaderboardIndexRoute: typeof AuthenticatedLeaderboardIndexRoute
  AuthenticatedMyCampaignsIndexRoute: typeof AuthenticatedMyCampaignsIndexRoute
  AuthenticatedPrivacyPolicyIndexRoute: typeof AuthenticatedPrivacyPolicyIndexRoute
  AuthenticatedShowcasesIndexRoute: typeof AuthenticatedShowcasesIndexRoute
  AuthenticatedTermsOfServiceIndexRoute: typeof AuthenticatedTermsOfServiceIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWalletIndexRoute: typeof AuthenticatedWalletIndexRoute
  AuthenticatedCampaignsIdClipperRoute: typeof AuthenticatedCampaignsIdClipperRoute
  AuthenticatedCampaignsIdManageRoute: typeof AuthenticatedCampaignsIdManageRoute
  AuthenticatedBlogsSlugIndexRoute: typeof AuthenticatedBlogsSlugIndexRoute
  AuthenticatedCampaignsIdIndexRoute: typeof AuthenticatedCampaignsIdIndexRoute
  AuthenticatedIdIdIndexRoute: typeof AuthenticatedIdIdIndexRoute
  AuthenticatedShowcasesShowcaseIdIndexRoute: typeof AuthenticatedShowcasesShowcaseIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountSettingsRouteRoute:
    AuthenticatedAccountSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedRCodeRoute: AuthenticatedRCodeRoute,
  AuthenticatedUsernameIndexRoute: AuthenticatedUsernameIndexRoute,
  AuthenticatedBlogsIndexRoute: AuthenticatedBlogsIndexRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
  AuthenticatedLeaderboardIndexRoute: AuthenticatedLeaderboardIndexRoute,
  AuthenticatedMyCampaignsIndexRoute: AuthenticatedMyCampaignsIndexRoute,
  AuthenticatedPrivacyPolicyIndexRoute: AuthenticatedPrivacyPolicyIndexRoute,
  AuthenticatedShowcasesIndexRoute: AuthenticatedShowcasesIndexRoute,
  AuthenticatedTermsOfServiceIndexRoute: AuthenticatedTermsOfServiceIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWalletIndexRoute: AuthenticatedWalletIndexRoute,
  AuthenticatedCampaignsIdClipperRoute: AuthenticatedCampaignsIdClipperRoute,
  AuthenticatedCampaignsIdManageRoute: AuthenticatedCampaignsIdManageRoute,
  AuthenticatedBlogsSlugIndexRoute: AuthenticatedBlogsSlugIndexRoute,
  AuthenticatedCampaignsIdIndexRoute: AuthenticatedCampaignsIdIndexRoute,
  AuthenticatedIdIdIndexRoute: AuthenticatedIdIdIndexRoute,
  AuthenticatedShowcasesShowcaseIdIndexRoute:
    AuthenticatedShowcasesShowcaseIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  SsoCallbackRoute: SsoCallbackRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
